import { ComponentStyleProps } from "../../../lib/styles/props/component-style-props";
import React from "react";
import {
  Box,
  ComponentMultiStyleConfig,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { ReplyCommentBlockItemContent } from "../types";
import { CMFileUploadItem } from "../../file-upload";
import { CMDatetimeText } from "../../text";

export type CMReplyCommentBlockItemProps = {
  /**
   * 表示用のデータ
   */
  content: ReplyCommentBlockItemContent;

  /**
   * ファイルが選択されたときに、そのファイルを引数として呼び出される。
   * @param fileId
   * @param fileName ファイル名
   */
  onDownloadFile?: (fileId: string, fileName: string) => void;
} & ComponentStyleProps;

/**
 * 送信者情報とメッセージ本文を表示する。
 *
 * メッセージエリアはデフォルト2行分表示。
 * 既読更新イベントが未定義の場合、ボタン非表示。
 */
export const CMReplyCommentBlockItem = ({
  content,
  onDownloadFile,

  sx,
  ...rest
}: CMReplyCommentBlockItemProps) => {
  const styles = useMultiStyleConfig("CMReplyCommentBlockItemStyles");

  return (
    <Box sx={{ ...styles.container, ...sx }} {...rest}>
      {/*ヘッダー*/}
      <Box sx={styles.headerArea}>
        {/*送信者の情報*/}
        <Box sx={styles.senderArea}>
          <Text sx={styles.senderLabel}>{content.senderLabel}</Text>
          <Text sx={styles.separator}> {content.separator}</Text>
          <Text sx={styles.senderName}>{content.senderName}</Text>
        </Box>
        {/*返信日時の情報*/}
        <Box sx={styles.replyDateArea}>
          <CMDatetimeText value={content.date} sx={styles.date} />
        </Box>
      </Box>

      {/*メインエリア*/}
      <Box sx={styles.mainArea}>
        <Box sx={styles.commentArea}>
          {/*コメント本文*/}
          <Box sx={styles.commentBox}>
            <Text sx={styles.comment}>{content.mainText}</Text>
          </Box>
          {/*ファイル一覧*/}
          <Box sx={styles.filesArea}>
            {content.files.map((file, index) => (
              <CMFileUploadItem
                key={index}
                editMode={"readOnly"}
                fileItem={file}
                onDownload={onDownloadFile}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export const CMReplyCommentBlockItemStyles: ComponentMultiStyleConfig = {
  parts: [
    "container",
    "headerArea",
    "senderArea",
    "senderLabel",
    "separator",
    "senderName",
    "replyDateArea",
    "mainArea",
    "commentArea",
    "commentBox",
    "comment",
    "filesArea",
  ],
  baseStyle: {
    container: {},
    headerArea: {
      display: "flex",
      flexDirection: "row",
      color: "gray.500",
    },

    senderArea: {
      display: "flex",
      flexDirection: "row",
      fontSize: "16px",
      width: "fit-content",
      whiteSpace: "pre-wrap",
    },
    senderLabel: {},
    separator: {
      marginLeft: "2px",
      whiteSpace: "nowrap",
    },
    senderName: {
      marginLeft: "5px",
    },

    replyDateArea: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      alignItems: "end",
      fontSize: "14px",
      marginLeft: "auto",
      right: "30px",
    },

    mainArea: {
      position: "relative",
      marginTop: "3px",
      marginLeft: "10px",
    },

    commentArea: {},
    commentBox: {
      h: "fit-content",
      color: "gray.900",
    },

    comment: {
      whiteSpace: "pre-wrap",
    },

    filesArea: {
      marginTop: "6px",
      marginLeft: "-3px",
    },
  },
};
